export const allDevicesCheckoutAddress = () => {
    $('#shipping-info input[type=radio]').on('change', function(event) {
        if ($(this).prop("checked") == true) {
            $('.address-checkout').removeClass('active');
            $(this).parents("li").find('.address-checkout').addClass('active');
        };
    });
};
